import { Directive, ElementRef, EventEmitter, HostListener, Input, NgModule, Output, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SortType } from '../intefaces/sort-type';

@Directive({
  selector: '[lcmsSortWithSubject]',
})
export class SortWithSubjectDirective {
  targetElem: ElementRef = inject(ElementRef);

  @Output() sortOrder = new EventEmitter<SortType>();

  @Input() dataName: string;

  order:'asc' | 'desc' = 'desc';

  @HostListener('click')
  onClick() {
    // Get Reference Of Current Clicked Element
    const elem = this.targetElem.nativeElement;

    // Define arrow symbols
    const ascendingArrow = ' ↑';
    const descendingArrow = ' ↓';

    // Remove arrow symbol from all siblings
    const siblings = Array.from(elem.parentNode.children);
    siblings.forEach((sibling: any) => {
      if (sibling != elem && sibling.innerHTML.includes(ascendingArrow)) {
        sibling.innerHTML = sibling.innerHTML.replace(ascendingArrow, '');
      } else if (
        sibling != elem &&
        sibling.innerHTML.includes(descendingArrow)
      ) {
        sibling.innerHTML = sibling.innerHTML.replace(descendingArrow, '');
      }
    });

    // Toggle order
    if (this.order === 'desc') {
      elem.setAttribute('data-order', 'asc');
      // Remove any existing arrow symbol first
      if (elem.innerHTML.includes(ascendingArrow)) {
        elem.innerHTML = elem.innerHTML.replace(ascendingArrow, '');
      }
      elem.innerHTML += descendingArrow; // Append descending arrow to element
      this.order = 'asc';
    } else {
      elem.setAttribute('data-order', 'desc');
      // Remove any existing arrow symbol first
      if (elem.innerHTML.includes(descendingArrow)) {
        elem.innerHTML = elem.innerHTML.replace(descendingArrow, '');
      }
      elem.innerHTML += ascendingArrow; // Append ascending arrow to element
      this.order = 'desc';
    }

    // Emit sort parameters
    this.sortOrder.emit({
       name: this.dataName,
       order: this.order
    });
  }
}

@NgModule({
  imports: [CommonModule],
  declarations: [SortWithSubjectDirective],
  exports: [SortWithSubjectDirective],
})
export class SortWithSubjectDirectiveModule {}
